import { BASE_STATUS_TYPE, TEMPLATE_TYPE } from './common';

// 默认流程步骤信息（用于添加新步骤）
export const DEFAULT_PROCESS_INFO = {
  remark: '步骤1',
  process_type: undefined,
  process_name: '', // 步骤名
  process_desc: '', // 步骤描述
};

// 默认模板信息（用于新建模板时的初始值）
export const DEFAULT_TEMPLATE_INFO = {
  remark: '步骤1',
  type: TEMPLATE_TYPE.TEXT.value,
  need_qa: BASE_STATUS_TYPE.YES.value,
  process_type: undefined,
  process_name: '', // 步骤名
  process_desc: '', // 步骤描述
};

// 图片尺寸预设
export const IMAGE_SIZE_PRESETS = {
  '1K': [
    { label: '1024 × 1024 (1:1)', width: 1024, height: 1024 },
  ],
  '2K': [
    { label: '2048 × 2048 (1:1)', width: 2048, height: 2048 },
    { label: '1728 × 2304 (3:4)', width: 1728, height: 2304 },
    { label: '1664 × 2496 (2:3)', width: 1664, height: 2496 },
    { label: '1440 × 2560 (9:16)', width: 1440, height: 2560 },
    { label: '1296 × 3024 (9:21)', width: 1296, height: 3024 },
  ],
  '4K': [
    { label: '4096 × 4096 (1:1)', width: 4096, height: 4096 },
    { label: '3520 × 4694 (3:4)', width: 3520, height: 4694 },
    { label: '3328 × 4992 (2:3)', width: 3328, height: 4992 },
    { label: '3040 × 5404 (9:16)', width: 3040, height: 5404 },
    { label: '2656 × 6198 (9:21)', width: 2656, height: 6198 },
  ],
};
